// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__seIrU","innerCircle":"Loader_innerCircle__wroKY","inner":"Loader_inner__oHtNX","outerCircle":"Loader_outerCircle__KMGzu","outer":"Loader_outer__Ozmxp"};